import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';
import Select from 'react-select';

const ShopGroup = (props) => {
  const { user } = props;
  const { siteId, mallId } = useParams();
  const [shopMaster, setShopMaster] = useState(null);
  const [shopGroupData, setShopGroupData] = useState([]);
  const [shop, setShopValues] = useState([]);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();

  const PAGE_SIZE = 10;

  const [values, setValues] = useState({
    shop_group_id: null,
    shop_group_name: '',
    system_flg: constClass.FLAG.OFF,
  });

  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const refreshData = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    const shopGroup = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/shopgroup/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    setShopGroupData(shopGroup);
    const shop = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/shop/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    })).data.map((val) => { return { value: val.shop_id, label: val.shop_name }; });;
    setShopMaster(shop);
  }, [siteId, mallId]);

  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    const temp = data;
    const shopValues = data.m_shop_group_shop.map(a => ({ value: a.shop_id, label: shopMaster.find(x => x.value === a.shop_id).label }));
    if (shopValues.length > 0) {
      setShopValues(shopValues);
    }
    setValues(temp);
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      shop_group_id: null,
      shop_group_name: '',
      system_flg: constClass.FLAG.OFF,
    });
    setShopValues([]);
  }

  /* DB更新 */
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!data.shop_group_name) {
      window.alert('店舗グループ名を入力してください。');
      return;
    }
    var params = data;
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;
    params.mall_id = mallId;

    if (shop.length > 0) {
      params.m_shop = shop.map(shop => ({ site_id: siteId, shop_id: shop.value}));
    }

    let res;
    try {
      setLockData(true);
      if (params.shop_group_id === null || params.shop_group_id === "") {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/shopgroup/insert`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      } else {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/shopgroup/update/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      }
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }
  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`店舗グループ[${data.shop_group_id}:${data.shop_group_name}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      shop_group_id: data.shop_group_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/shopgroup/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const handleChangeShop = (data) => {
    setShopValues(data);
  }

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.shop_group_name === '' || data.system_flg === constClass.FLAG.ON}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.shop_group_id === null || data.system_flg === constClass.FLAG.ON}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  useEffect(() => {
    refreshData();
  }, [refreshData]); //

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>店舗グループID</span>
          </div>
          <div className="col-2 text-center align-self-center">
            <input
              type="text"
              className="form-control"
              name="shop_group_id"
              defaultValue={values.shop_group_id}
              placeholder="新規"
              readOnly
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>店舗グループ名</span>
          </div>
          <div className="col-5 text-center align-self-center">
            <input
              type="text"
              className="form-control"
              name="shop_group_name"
              value={values.shop_group_name}
              onChange={handleChange}
              placeholder="店舗グループ名を入力してください"
              disabled={values.system_flg === constClass.FLAG.ON}
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="system_flg">システム連携フラグ</label>
          </div>
          <div className="col-5 align-self-center">
            <input
              type="checkbox"
              className="form-control w-25"
              name="system_flg"
              value="true"
              checked={values.system_flg === constClass.FLAG.ON}
              onChange={handleChange}
              disabled={true}
            ></input>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="use_flg">所属店舗</label>
          </div>
          <div className="col-10 text-center align-self-center">
            <Select options={shopMaster} isDisabled={values.system_flg === constClass.FLAG.ON} isMulti closeMenuOnSelect={false} value={shop} onChange={handleChangeShop} placeholder="所属する店舗を選択してください" />
          </div>
        </div>
        <div className="row mb-2 pb-4">
          <div className="col-3 text-center">{renderRegistButton(values)}</div>
          <div className="col-3 text-center">{renderDeleteButton(values)}</div>
          <div className="col-3 text-center">{renderResetButton(values)}</div>
        </div>
      </div>
    );
  };

  const renderList = () => {
    const filteredData = shopGroupData.filter(data =>
      !searchKeyword || data.shop_group_name.includes(searchKeyword)
    );
    const totalPages = Math.ceil(filteredData.length / PAGE_SIZE);
    const pagedData = filteredData.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

    return (
      <div className="row mb-3 p-0 mt-2">
        <div className="col-12 mb-2">
          <div className="row">
            <input
              type="text"
              className="col-4 form-control"
              placeholder="店舗グループ名で絞り込み"
              value={searchKeyword}
              onChange={e => { setSearchKeyword(e.target.value); setCurrentPage(1); }}
            />
          </div>
        </div>
        <div className="col-12 p-0">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span className="small text-muted">{filteredData.length}件中 {Math.min((currentPage - 1) * PAGE_SIZE + 1, filteredData.length)}〜{Math.min(currentPage * PAGE_SIZE, filteredData.length)}件表示</span>
            {totalPages > 1 && (
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>‹</button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>›</button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">店舗グループID</td>
                <td className="text-center align-middle">店舗グループ名</td>
                <td className="text-center align-middle">システム連携フラグ</td>
                <td className="text-center align-middle">処理</td>
              </tr>
            </thead>
            <tbody>
              {pagedData.map((data) => (
                <tr key={data.shop_group_id}>
                  {/* 店舗グループID */}
                  <td className="text-center align-middle">
                    {data.shop_group_id}
                  </td>
                  {/* 店舗グループ名 */}
                  <td className="text-center align-middle">
                    {data.shop_group_name}
                  </td>
                  {/* システム連携フラグ */}
                  <td className="text-center align-middle">
                    {data.system_flg === constClass.FLAG.ON ? "〇" : "×"}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="container">
      {shopGroupData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {shopGroupData !== null && (renderList())}
      {renderInput()}
    </div>
  )
}

export default ShopGroup;